module.exports = __webpack_public_path__ + "static/media/sistel-logo-wide.8e3fd34d.png";